import { call, put, select } from 'redux-saga/effects';
import { sidePanelClosed } from 'features/side-panels/sidePanelsSlice';
import type { signalingQuizEnded } from 'features/quizzes/actions';
import { closeQuizTakeRequestNotificationSaga } from 'features/quizzes/sagas/closeQuizTakeRequestNotificationSaga';
import { selectIsSystemSession } from 'features/application/selectors';

export function* onQuizEndedSaga(action: ReturnType<typeof signalingQuizEnded>) {
  yield call(closeQuizTakeRequestNotificationSaga, action.payload.data.id);

  const isSystemSession: boolean = yield select(selectIsSystemSession);
  if (isSystemSession) {
    yield put(sidePanelClosed('polls'));
  }
}
